import { Component } from '@angular/core';

@Component({
    selector: 'app-custom-error-page',
    templateUrl: './custom-error-page.component.html'
})
export class CustomErrorPageComponent {}
